import moment from 'moment';

export const CONVENTIONS_FILTERS_KEY = 'convencoes';

// Year kept as a 'YYYY' string (the Select gives numbers; see normalizeYear).
export const getDefaultConventionsFilters = () => ({
  year: moment().format('YYYY'),
});

export const normalizeYear = (value) => String(value);

// Same endpoint the year Select uses, so the mount load and a year change agree.
export const getConventionsRequest = (filters) => ({
  url: '/conventions/year/' + normalizeYear(filters.year),
});

export const isSameConventionsRequest = (a, b) =>
  getConventionsRequest(a).url === getConventionsRequest(b).url;

// Badge: only what differs from the defaults.
export const countActiveConventionsFilters = (filters, defaults) =>
  normalizeYear(filters.year) !== normalizeYear(defaults.year) ? 1 : 0;

// Years offered in the Select: next year down to 2018, newest first.
export const getConventionYears = (now) => {
  const currentYear = (now || moment()).year();
  const back = currentYear - 2016;
  return Array.from({ length: back }, (v, i) => currentYear + 1 - back + i + 1).sort((a, b) => b - a);
};
